import { h } from "preact";
import { Link } from "preact-router/match";
import Picture from "./Picture";
import { css } from "emotion";
import colorContrast from "color-contrast";

const ContactLink = ({ event, primaryColor }) => {
  return (
    <Link href={`/${event.slug}/contact`} style={{ color: primaryColor }}>
      CONTACT ORGANISER
    </Link>
  );
};

const OrganiserLink = ({ event, linkSpans, primaryColor }) => {
  if (!event.organiserId) {
    return null;
  }
  return (
    <span className={linkSpans} style={{ marginLeft: 24 }}>
      <a
        href={`/organisers/${event.organiserId}`}
        style={{ color: primaryColor }}
      >
        VIEW PROFILE
      </a>
    </span>
  );
};

const OrganiserInfo = ({ event, hideContactLink, hideLogo }) => {
  if (!event) {
    return null;
  }
  const primaryColor =
    event.theme && event.theme.primaryColor
      ? event.theme.primaryColor
      : "#6621c0";

  const outerWrapper = css({
    width: "100%",
    "@media(max-width: 600px)": {
      borderTop: "1px solid #DEDEDE"
    }
  });

  const colorCode = ["#323232", "#FFFFFF"];
  let primaryTextColor = "#323232";
  if (event.theme && event.theme.primaryColor) {
    colorCode.forEach(color => {
      if (colorContrast(primaryColor, color) >= 4.5) {
        primaryTextColor = color;
      }
    });
  }

  const wrapper = css({
    border: "1px solid #DEDEDE",
    borderRadius: 5,
    padding: 24,
    textAlign: "center",
    "@media(max-width: 700px)": {
      border: "none",
      paddingLeft: 0,
      paddingRight: 0
    }
  });

  const pictureStyle = css({
    width: 100,
    height: 100,
    display: "inline-block",
    marginBottom: 16,
    overflow: "hidden",
    borderRadius: "50%",
    "@media(max-width: 700px)": {
      marginBottom: 12,
      width: 80,
      height: 80
    }
  });

  const noPicture = css({
    backgroundColor: `${primaryColor}`,
    fontSize: 26,
    borderRadius: 4,
    width: "100%",
    height: "100%",
    paddingTop: 30,
    "@media(max-width: 700px)": {
      fontSize: 18
    }
  });

  const eventDescription = css({
    margin: "0 auto",
    maxWidth: 500,
    fontSize: 14,
    "@media(max-width: 700px)": {
      textAlign: "left",
      maxWidth: "100%",
      overflowWrap: "break-word",
      wordBreak: "break-all",
      wordBreak: "break-word",
      hyphens: "auto"
    }
  });

  const infoLinks = css({
    paddingLeft: 8,
    marginBottom: 16,
    paddingRight: 8,
    "@media(max-width: 700px)": {
      fontSize: 14,
      marginBottom: 12,
      padding: 0
    }
  });

  const linkColor =
    event.theme && event.theme.linkColor ? event.theme.linkColor : "#6621c0";

  const linkSpans = css({
    a: {
      color: linkColor,
      fontWeight: 600
    },
    svg: {
      fill: linkColor
    }
  });

  const title = event.organiser ? `${event.organiser.name}` : `Event organiser`;
  const contactInfo = hideContactLink ? null : <ContactLink event={event} primaryColor={primaryColor}/>;

  //getting acronym from event organisers name if no picture supplied
  const organiserName = event.organiser ? event.organiser.name : false;
  const acronym = organiserName
    ? organiserName
        .split(/\s/)
        .reduce((response, word) => (response += word.slice(0, 1)), "")
    : false;

  let eventDescText =
    event.organiser && event.organiser.description
      ? event.organiser.description
      : null;

  const showReadMore =
    eventDescText && eventDescText.length > 290 ? true : false;
  eventDescText = showReadMore
    ? eventDescText.substring(0, 290)
    : eventDescText;
  const organiserLogo =
    event.organiser && event.organiser.logo ? event.organiser.logo : false;

  const showPicture = organiserLogo || organiserName ? true : false;

  return (
    <div className={outerWrapper}>
      <div className={wrapper}>
        {showPicture ? (
          <div className={pictureStyle}>
            {organiserLogo ? (
              <Picture
                img={organiserLogo}
                alt={`${organiserName} logo`}
                width={100}
              />
            ) : organiserName ? (
              <div className={noPicture}>
                <div
                  style={{ display: "inline-block", color: primaryTextColor }}
                >
                  {acronym}
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
        <h3 id="organiserInfoBox" style={{ fontWeight: 600, marginBottom: 12 }}>
          {title}
        </h3>
        <div className={infoLinks}>
          <span className={linkSpans}>{contactInfo}</span>
          <OrganiserLink event={event} linkSpans={linkSpans} primaryColor={primaryColor}/>
        </div>
        <p className={eventDescription}>
          {eventDescText}
          {showReadMore ? (
            <span>
              ... <a href={`/organisers/${event.organiserId}`}>Read more</a>
            </span>
          ) : null}
        </p>
      </div>
    </div>
  );
};

export default OrganiserInfo;
